import { render, staticRenderFns } from "./AspectRatio.vue?vue&type=template&id=1ff23be2&functional=true"
import script from "./AspectRatio.vue?vue&type=script&lang=js"
export * from "./AspectRatio.vue?vue&type=script&lang=js"
import style0 from "./AspectRatio.vue?vue&type=style&index=0&id=1ff23be2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports